<template>
  <v-menu offset-y left origin="right top" z-index="99" content-class="notification-dropdown" transition="slide-y-transition" nudge-top="-10" :close-on-content-click="false" v-model="opened">
    <template v-slot:activator="{ on }">
      <v-badge color="red" overlap :value="notifications.length">
        <template v-slot:badge>
          <div class="pos-relative">
            {{ notificationsCount }}
            <span class="visually-hidden">notifications</span>
          </div>

        </template>
        <v-btn icon v-on="on">
          <v-icon>mdi-bell</v-icon>
          <span class="visually-hidden text-lowercase">Notifications</span>
        </v-btn>
      </v-badge>
    </template>

    <div class="dropdown-content">
      <v-progress-linear absolute :active="loading" indeterminate />
      <div class="notifications-area" v-if="notifications.length">
        <dismiss-all location="header" @update="updateData" />
        <div class="dropdown-list">
          <ul>
            <li v-for="item in notifications" :key="item.id">
              <notification-item :item="item" @visit="visitNotification" @dismiss="dismissNotification" />
            </li>
          </ul>
        </div>

        <view-all-notifications @close="opened = false" />

      </div>
      <div class="notifications-area-empty" v-else>
        <no-notifications />
        <view-all-notifications @close="opened = false" />
      </div>
    </div>

  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { openNotification } from 'Helpers/notifications'
import NotificationItem from '@/components/General/Header/Notifications/NotificationItem'
import NoNotifications from '@/components/General/Header/Notifications/NoNotifications'
import ViewAllNotifications from '@/components/General/Header/Notifications/ViewAllNotifications'
import DismissAll from 'Components/General/Header/Notifications/DismissAll'

export default {
  name: 'Notifications',
  components: {
    NotificationItem, NoNotifications, ViewAllNotifications, DismissAll
  },
  data: () => ({
    opened: false,
    loading: false
  }),
  methods: {
    ...mapActions({
      dismiss: 'notifications/notificationDismiss',
      getUrl: 'notifications/notificationVisit',
      updateAll: 'notifications/updateAll',
      reportError: 'reportError'
    }),
    async dismissNotification (id) {
      try {
        this.loading = true
        await this.dismiss(id)
        await this.updateData()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    async visitNotification (id) {
      try {
        // Close menu
        this.opened = false

        const url = await this.getUrl(id)

        openNotification(url)

        await this.updateData()
      } catch (e) {
        this.reportError(e)
      }
    },
    async updateData () {
      try {
        this.loading = true
        await this.updateAll()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notifications/notifications',
      notificationsCount: 'notifications/notificationsCount'
    })
  }
}
</script>

<style lang="scss" scoped>
.dropdown-list {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {

    }
  }
}

.notifications-area-empty {
  position: relative;
  height: 98px;
}

.notifications-area {
  position: relative;
  height: 450px;
  overflow-y: auto;
  padding-bottom: 40px;
}

.notifications-label-hidden {
  position: absolute;
  left: -99999px;
}
</style>
